const isPopupLogin = (query) => {
  return (
    query.is_popup_login &&
    window.opener &&
    window.opener.location?.href?.includes('unacademy.com') &&
    window.opener.postMessage
  );
};

export default isPopupLogin;
